import React from "react";
import { CalendarDays } from "lucide-react";
import { formatBulandiEventScheduleLabel } from "../../../data/bulandiEventSchedule";

export function EventScheduleBadge({ eventId, className = "" }) {
  const label = formatBulandiEventScheduleLabel(eventId);
  if (!label) return null;

  return (
    <span
      className={`inline-flex min-w-0 max-w-full shrink items-center gap-1 rounded-full border border-bul-lime/40 bg-bul-lime/10 px-2.5 py-1 font-mono text-[10px] font-bold uppercase leading-snug tracking-wider text-bul-lime sm:ml-auto sm:shrink-0 sm:px-3 sm:text-[11px] ${className}`.trim()}
    >
      <CalendarDays className="h-3 w-3 shrink-0" aria-hidden strokeWidth={2.5} />
      <span className="truncate">{label}</span>
    </span>
  );
}
